module.exports = __webpack_public_path__ + "static/media/walner.511b6ed9.png";